import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"


class ChangePassUseradm extends Component {

  constructor(props) {
    super(props);
   
  }

  state ={
    nome:null,
    cpf:null,
    email:null,
    telefone1:null,
    telefone2:null,
    iduser:this.props.match.params.iduser,
    aluno:[]
  }
 
  async componentDidMount(){
   

    const {iduser} = this.state;
    const response = await api.post("admin/user/id", {iduser});

    this.setState({
      aluno:response.data.success,
      nome:response.data.success.nomecompleto,
    cpf:response.data.success.cpf,
    telefone1:response.data.success.telefone1,
    telefone2:response.data.success.telefone2,
    email:response.data.success.user.email
    })

    



  }

 



 













  onFormSubmit = async e =>{
    e.preventDefault() ;

    const { newpass, iduser } = this.state;
      if (!iduser || !newpass ) {
          this.setState({ error: "Preencha os campos antes de editar!",
        success:null });
      } else {
      const response = await api.post("/admin/user/changepass", { newpass,iduser });
       

        if(response.data.success.id){
          this.setState({ success: "Senha Alterada!" , error:null,
        });
        }

      }
  }



  render() {

    
    return (
      <React.Fragment>
          <Header />
        <div class="container col-lg-4 p-4">     

        <h4>Alterar Senha de Aluno</h4>     
        <form  onSubmit={this.onFormSubmit}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" defaultValue={this.state.nome} onChange={e => this.setState({ nome: e.target.value })} readOnly />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail</label>
                    <input type="text" class="form-control" defaultValue={this.state.email} onChange={e => this.setState({ email: e.target.value })}  readOnly/>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">CPF</label>
                    <input type="text" class="form-control" defaultValue={this.state.cpf} onChange={e => this.setState({ cpf: e.target.value })} readOnly />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nova Senha</label>
                    <input type="password" class="form-control" defaultValue={this.state.newpass} onChange={e => this.setState({ newpass: e.target.value })}  />
                </div>
               

               
                





                <div class="form-group">
                <button class="btn btn-primary mb-2" >Atualizar Aluno</button>
 {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(ChangePassUseradm);


// WEBPACK FOOTER //
// ./src/pages/Admin/changepassuser.js